<template>
    <section>

        <div class="page">
            <div>
                <h2>How to forward messages</h2>
                <p>The <strong>Forward</strong> feature allows you to forward messages from a group or individual chat
                    to another group or
                    individual chat.
                </p>
                <h3>To forward messages</h3>
                <ol>
                    <li>In a group or individual chat, tap and hold the message you want to forward, then tap <strong>
                        Forward</strong>.
                    </li>
                    <ul>
                        <li>To forward multiple messages, you can check additional messages after you select the first
                            message.
                        </li>
                    </ul>
                    <li>Tap <strong>Forward</strong>on the prompted menu.</li>
                    <li>Search for or select the groups or individual chats you want to forward the message to.</li>
                    <li>Tap <strong>Send</strong>.</li>
                </ol>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
